import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertNumWithOtherCharsToBn',
    standalone: false
})
export class ConvertNumWithOtherCharsToBnPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }
    
    const digitMap: { [key: string]: string } = {
      '0': '০',
      '1': '১',
      '2': '২',
      '3': '৩',
      '4': '৪',
      '5': '৫',
      '6': '৬',
      '7': '৭',
      '8': '৮',
      '9': '৯'
    };

    const convertedValue = value.replace(/[0-9]/g, (match) => digitMap[match] || match);

    return convertedValue;
  }

}
